import * as React from "react"

import { cn } from "@/lib/utils"

const cardVariants = {
  default: "rounded-xl border bg-card text-card-foreground shadow",
  acta:
    "rounded-[16px] border border-[var(--do-border)] bg-[var(--do-bg-solid)] text-[var(--do-ink)] shadow-none",
  actaSubtle:
    "rounded-[16px] border border-[var(--do-border)] bg-[var(--do-bg-2)] text-[var(--do-ink)] shadow-none",
  actaInteractive:
    "rounded-[16px] border border-[var(--do-border)] bg-[var(--do-bg-solid)] text-[var(--do-ink)] shadow-none transition-colors hover:border-[var(--do-border-strong)] hover:bg-[var(--do-bg-2)]",
}

const Card = React.forwardRef(({ className, variant = "default", ...props }, ref) => (
  <div
    ref={ref}
    className={cn(cardVariants[variant] || cardVariants.default, className)}
    {...props} />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props} />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("font-semibold leading-none tracking-tight", className)}
    {...props} />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props} />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props} />
))
CardFooter.displayName = "CardFooter"

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
  cardVariants,
}
